const tokenType = {
  SSO: 'SSO',
  AAD: 'AAD'
};

export default tokenType;
